var _defs, _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOrangeFlag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg-follow",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffa023;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 16,
    height: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-follow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    className: "cls-1",
    d: "m13.13,6.96l-.1.1-8.03,2.85.03-1.12,6.67-2.37L3.99,3.69v9.64h-1.32V3.24l.11-.12c.24-.27.85-.44,1.17-.45h.17l8.93,3.16.1.11c.25.28.25.76-.01,1.03h0Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeFlag);
export default __webpack_public_path__ + "static/media/orange-flag.90b7dafa.svg";
export { ForwardRef as ReactComponent };